import styled, {css} from 'styled-components';
import { MediaStyle } from '../../utils/style-utils';

export const CartItemWrapper = styled.div`
  margin-bottom: 15px;
`;

export const CartToolbarWrapperStyle = styled.div`
  margin-top: 20px;
  button {
    margin-right: 10px;
  }
  ${ MediaStyle.md`
    max-width: 1182px;
    margin: 25px auto 0;
    padding: 0 10px;
    button {
      margin-right: 0;
    }
  ` }
  
  ${props => props.isDisabled && css`
    button {
      opacity: 0.5;
      pointer-events: none;
    }
  `}
`;

export const PdfButtonContainerStyle = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  button {
    margin-right: 10px;
  }
  ${ MediaStyle.md`
    max-width: 1182px;
    margin: 25px auto 0;
    padding: 0 10px;
    button {
      margin-right: 0;
    }
  ` }
`;



// WEBPACK FOOTER //
// ./src/components/checkout/style.js